import FareTableContainerMobile from '../../../../components/containers/FareTableContainerMobile';
import preloadCustomProps from '../../../utils/preloads/preloadFareProps';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'fare-table--mobile',
  moduleId: 'em-cmp-lib-airmodules',
  staticAssetsHost: 'https://em-frontend-assets.airtrfx.com',
  version: 'NO_NEEDED',
  containerConfig: {
    settings: {
      instance: FareTableContainerMobile
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
